import { withPropsOnChange } from 'recompose'

import {
  esuzConfigName,
} from '../withEsuzIssue'
import {
  toirConfigName,
} from '../withToirIssue'
import { ISSUE_LINK_SYSTEM_TYPE } from '../constants'

const withConfig = withPropsOnChange(
  [`issueLinkSystemType`, esuzConfigName, toirConfigName],
  ({
    issueLinkSystemType,
    [esuzConfigName]: esuzConfig,
    [toirConfigName]: toirConfig,
  }) => {
    let config = {}

    if (issueLinkSystemType === ISSUE_LINK_SYSTEM_TYPE.ahp) {
      config = { ...esuzConfig }
    }
    if (issueLinkSystemType === ISSUE_LINK_SYSTEM_TYPE.toir) {
      config = { ...toirConfig }
    }
    return {
      ...config,
    }
  },
)

export default withConfig
